module.exports = __webpack_public_path__ + "media/packs/images/flags/AM-db1b7f7034ff31b4174b417aeb49103f.svg";